import { render, staticRenderFns } from "./addMember.vue?vue&type=template&id=6863fd96&scoped=true&"
import script from "./addMember.vue?vue&type=script&lang=js&"
export * from "./addMember.vue?vue&type=script&lang=js&"
import style0 from "./addMember.vue?vue&type=style&index=0&id=6863fd96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6863fd96",
  null
  
)

export default component.exports